/* TODO: t() */
import React from 'react';
import FormElementBase from '../FormElementBase';
import FieldEditor from './LocationInputElement/LocationInputElementFieldEditorView';
import FormView from './LocationInputElement/LocationInputElementFormView';
import EditView from './LocationInputElement/LocationInputElementEditView';
import ensureObject from '../../../support/shared/ensureObject';
import { Icon } from '../../uiold';

import IndexedList from '../../../support/shared/IndexedList';
import { Place } from '../../GooglePlacesAutocomplete';
import { FormFieldDefinition } from '../../../types/shared/FormFieldDefinition';
import { Market } from '../../../types/shared/Market';
import { Field } from '../../../types/shared/Vendor';

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: Place | null | undefined;
  // onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  fields: IndexedList<Field>;
};

type FormViewProps = {
  onChange?: (id: string, value: string) => void;
};

type EditViewProps = {
  value: Place | null | undefined;
  onChange: (id: string, value: Place | null | undefined) => void;
};

class LocationInputElement extends FormElementBase {
  static getType() {
    return 'LocationInput';
  }

  static getDescription() {
    return 'Location Input';
  }

  static getAttributes() {
    return {
      name: 'Location Input',
      label: 'Location Input',
      placeholder: null,
      hidden: false,
      is_required: false,
      is_public: false,
    };
  }

  static getIconName() {
    return 'location';
  }

  static getIcon() {
    return <Icon name="location" size="M" />;
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        readOnly={true}
      />
    );
  }

  renderFormView(props?: FormViewProps) {
    props = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { value } = props;
    let stringValue = '';
    let object = ensureObject(value);
    if (object) {
      stringValue = typeof object.textName === 'string' ? object.textName : '';
    }
    return <span className="location-input">{stringValue}</span>;
  }

  renderEditView(props: EditViewProps) {
    return (
      <EditView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }
}

export default LocationInputElement;
